import type React from 'react';

/**
 * Returns styles for the frame content.
 * Note: --inverse-zoom CSS variable is inherited from the ReactFlow container
 * via ZoomCSSVariableSync component, so we don't need to set it here.
 */
export const getFrameStyles = (
  themeProperties: Record<string, string> | undefined,
): React.CSSProperties => {
  return {
    ...themeProperties,
    // In the future the line below will be set by the LLM where needed
    fontFamily: 'var(--font-body, var(--font-sans, var(--font-family-body)))',
  };
};
